import React, {FC} from 'react';
import Chart from 'react-apexcharts'
import {PricingSerie, PricingData} from './core/_models'

interface Props {
  data: PricingSerie[]
}

const PricingChart: FC<Props> = ({data}) => {
  const categories: Date[] = []
  const series = data.map((d: PricingSerie) => {
    return {
      name: d.supplier,
      data: d.pricing.map((p: PricingData) => {
        categories.push(p.date)
        return p?.value?.avg || null
      })
    }
  })

  const options = {
    chart: {
      id: 'supplier-pricing-evolution',
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    xaxis: {
      type: 'datetime' as const,
      categories: categories,
      labels: {
        datetimeFormatter: {
          year: 'yyyy', // Format the year
          month: 'MMM yyyy', // Format the month
          day: 'dd MMM yyyy', // Format the day
          hour: 'HH:mm' // Format the hour
        }
      },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    dataLabels: {
      enabled: false
    },
    markers: {
      size: 5
    }
  }

  return (
    <Chart
      options={options}
      series={series}
      type="area"
      height={320}
    />
  )
}

export default PricingChart
